import { HostListener,Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { UserHandling } from '../shared/user-handling';
import { Router } from '@angular/router'

@Component({
    selector: 'welcome',
    templateUrl: 'welcome.html',
    styles: [ '.welcome-panel { text-align:center;margin:100px; }' ]
})
export class WelcomeComponent { 
    user: UserHandling = new UserHandling();
    constructor(        
        private route: Router,
    ) { }
    

    ngOnInit() {
        if ( this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsPartSupplierUser 
            || this.user.IsTestPackager 
            || this.user.IsDeveloper
             ) {
             this.route.navigate(['/dashboard']);//welcome
            return true;
        }
        // else{
        //     this.route.navigate(['/welcome']); 
        //     return true;
        // }
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/welcome/welcome.component.ts